const AlgoliaConstants = {
  hitsPerPage: 100
};

const PremiumExhibitorPrioritySlots = {
  gold: {
    desktopOrTablet: 2,
    mobile: 1
  },
  silver:  {
    desktopOrTablet: 5,
    mobile: 4
  },
}

const Platform = {
  vidyard: 'Vidyard'
}

const EXHIBITOR_INSIGHTS = {
  fromEditProfile: 'fromEditProfile',
  physicalShow: 'physical',
  virtualShow: 'virtual',
  hybridShow: 'hybrid'
}

const EXHIBITOR_INSIGHTS_TILE_TYPE={
  oldTile : 'ExhibitorInsightsOldTile',
  newTile : 'ExhibitorInsightsNewTile'
}

const MaxLength = {
  accompanyingWebsite: 120,
  phone: 30,
  email: 254,
  description: 600,
  showObjective: 200,
  name: 120,
  companyName: 120,
  companyNameAide: 120 * 7,
  sortAlias: 120,
  addressLine1: 150,
  addressLine2: 150,
  city: 60,
  stateProvince: 60,
  postcode: 20,
  website: 120,
  socialMediaUrl: 120,
  filterGroupName: 255,
  representedBrandsItemMaxLength: 18,
  productTitle: 50,
  productDescription: 500,
  session: 25,
  sessionDescription: 140,
  productsAndServices: 255,
  features: 25,
  firstName: 150,
  lastName: 150,
  productAttribute: 120,
  jobTitle: 60,
  sessionTitle: 135,
  sessionLocation: 100,
  thirdPartyVendorName: 35
};

const OrganisationGuidFacet = {
  organisationGuid: 'organisationGuid',
  networking: 'networking'
};

const CountryFilters = 'Country';

const PPSSortOrder = 'sortOrder';

const ExhibitorFeatures = {
  New: 'new_exhibitor',
  Innovator: 'innovator',
  NewProduct: 'new_product'
};

const EventEditionFeatures = {
  FranchiseLinks: 'FranchiseLinks',
  BasicPackageInclusion: 'BasicPackageInclusion',
  ProductCredits : 'ProductCredits',
  HideStandInfo: 'HideStandInfo',
  ExhibitorDirectoryRecommendation: 'ExhibitorDirectoryRecommendation'
};

const FilterGroupNames = {
  ProductsAndServices: 'products_and_services',
  Features: 'features',
  CountryName: 'country_name'
};

const FilterGroupIds = {
  ProductsAndServices: 13,
  Features: 14
}

const Buttons = {
  UpdateJobTitles: 'update',
  CancelUpdateJobtitles: 'cancel'
};

const FilterGroupURLNames = {
  products_and_services: 'products-and-services',
  features: 'features'
};

const FilterGroupProperties = {
  [FilterGroupNames.Features]: {
    maximumNonGlobalFilterItems: 20,
    staticFilterItems: [ExhibitorFeatures.Innovator, ExhibitorFeatures.New],
    maximumFilterItemLength: 25
  },
  [FilterGroupNames.ProductsAndServices]: {
    maximumNonGlobalFilterItems: 999,
    maximumFilterItemLength: 255,
    staticFilterItems: []
  }
};

const GbsCodesWithInvertedAddressOrder = ['OBU_018', 'OBU_008', 'OBU_011'];

const ProductsConstants = {
  maximumTagShowCount: 5,
  mobileMaxWidth: 376,
  tabletMaxWidth: 700,
  mobileLargeMaxWidth: 580,
  laptopMaxWidth: 992,
  desktopMaxWidth: 1200
};

const ProductCreditsConstants ={
  buyProductCreditsLink : 'https://register.onemip.com?pvlid=2e17b6e0-d641-4f1b-b803-5deca487a86c',
  entitlementProductType: 'Digital PCredit'
};

const DigitalIncentivesConstants = {
    validEntitlementProductNumbers: {
      preprod : ['4890010'],
      prod: ['4000388','4330067','4330068', '4330069', '4330073', '4330074', '4330075', '4330092', '4420018','4420020',
        '4440023', '4600206', '4600211', '4600207', '4600267', '4600217', '4600243', '4104696', '4101042', '4104719', '4104704',
        '4104697', '4105177', '4104990', '4104992', '4101070', '4101071', '4101072', '4101073', '4101074', '4101075', '4101076',
        '4101077', '4101078', '4101079', '4100836', '4100836', '4100716', '4106104', '4100837', '4100715', '4105084', '4104968',
        '4104958', '4101084', '48100060', '48200447', '48200566', '4330105']
      },
    validEntitlementProductCode: 'Digital Incentive – Bag Entry'
  };

const Devices = {
  desktop: 'desktop',
  mobile: 'mobile'
};

const PressReleaseDocumentType = 2;

const DocumentTypes = {
  1: 'other',
  2: 'press_release',
  3: 'white_paper',
  4: 'case_study',
  5: 'brochure'
};

const Packages = {
  bronze: 1,
  silver: 2,
  gold: 3,
  basic: 4
};
const PackageName = {
  BRONZE: 'BRONZE',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  BASIC: 'BASIC'
};

const ImageTypes = {
  productDetails: 'product-details',
  product: 'product',
  producerDetails: 'details',
  artist: 'artist'
};

const ScreenSizes = {
  large: 'large',
  small: 'small'
};

const ImageSizes = {
  profile: 'large',
  coverImage: 'cover',
  directory: 'small',
  product: 'product',
  artist: 'small'
};

const Modes = {
  private: 'private',
  protected: 'protected',
  public: 'public',
  mixed: 'mixed',
  participantProtected: 'participantProtected'
};

const ExhibitorTypes = {
  exhibitor: 1,
  mainStandHolder: 2,
  sharer: 3
};

const PrepopulationType = {
  product: 1,
  document: 2
};

const PrepopulationStatus = {
  notStarted: 1,
  inProgress: 2,
  completed: 3,
  noProductsError: 4,
  genericError: 5,
  noDocumentsError: 6,
  noPPSFiltersError: 7,
  noProfileQuestionsError: 8
};

const PrePopulateErrorMessage = {
  ProductsNotExist: 'prepopulation_products_does_not_exist',
  DocumentsDoesNotExist: 'prepopulation_documents_does_not_exist',
  NoPreviousExhibitingOrganisationFound: 'no_previous_exhibiting_organisation_found',
  PPSFiltersDoesNotExist: 'prepopulation_pps_filters_for_prepopulation_does_not_exist',
  ProfileQuestionsDoesNotExist: 'prepopulation_profile_questions_for_prepopulation_does_not_exist'
}

const FilterFieldNames = {
  filterName: 'filterGroupName',
  filterItems: 'filterItems'
};

const FilterFieldErrorSelectors = {
  filterItems: /filterItems(\W\d+\W)?/,
  filterGroupName: 'filterGroupName'
};

const ProfileFieldNames = {
  accompanyingWebsite: 'accompanyingWebsiteUrl',
  name: 'name',
  displayName: 'displayName',
  standReference: 'standReference',
  description: 'description',
  email: 'email',
  phone: 'phone',
  showObjective: 'showObjective',
  hideAddress: 'hideAddress',
  addressLine1: 'addressLine1',
  addressLine: 'addressLine',
  addressLine2: 'addressLine2',
  city: 'city',
  stateProvince: 'stateProvince',
  postcode: 'postcode',
  country: 'country',
  countryCode: 'countryCode',
  cntCode: 'cntCode',
  packageId: 'packageId',
  packageName: 'packageName',
  exhibitorTypeId: 'exhibitorTypeId',
  exhibitorTypeName: 'exhibitorTypeName',
  primaryAdministratorEmail: 'primaryAdministratorEmail',
  primaryAdministratorFirstName: 'primaryAdministratorFirstName',
  primaryAdministratorLastName: 'primaryAdministratorLastName',
  administratorEmail: 'administratorEmail',
  administratorFirstName: 'administratorFirstName',
  administratorLastName: 'administratorLastName',
  sortAlias: 'sortAlias',
  companyName: 'companyName',
  companyNameAide: 'companyNameAide',
  isPublished: 'isPublished',
  website: 'website',
  socialMediaUrl: 'socialMediaUrl',
  socialMedia: 'socialMedia',
  filterItems: 'filterItems',
  products: 'products',
  features: 'features',
  extraCharacteristics: 'extraCharacteristics',
  isNew: 'isNew',
  productsAndServices: 'productsAndServices',
  representedBrands: 'representedBrands',
  representedBrandsAsString: 'representedBrandsAsString',
  profileQuestions: 'profileQuestions',
  filterCategories: 'filterCategories',
  companyObjectives: 'companyObjectives',
  sponsoredCategory: 'sponsoredCategory',
  stand: 'stands'
};

const SortDirection = {
  ascending: 1,
  descending: -1
};

const ProductFieldNames = {
  title: 'name',
  description: 'description',
  isInnovative: 'isInnovative',
  isNew: 'isNew',
  videoId: 'videoId',
  extraCharacteristics:'extraCharacteristics',
  isPublished:'isPublished',
  productUrl:'productUrl'
};

const ProfileFieldErrorSelectors = {
  name: /multilingual\W\d+\W\.name/,
  displayName: /displayName/,
  description: /multilingual\W\d+\W\.description/,
  showObjective: /multilingual\W\d+\W\.showObjective/,
  addressLine1: /multilingual\W\d+\W\.address.addressLine1/,
  addressLine: /^addressLine1$/,
  addressLine2: /multilingual\W\d+\W\.address.addressLine2/,
  city: /multilingual\W\d+\W\.address.city/,
  stateProvince: /multilingual\W\d+\W\.address.stateProvince/,
  postcode: /multilingual\W\d+\W\.address.postcode/,
  country: /multilingual\W\d+\W\.address.country/,
  countryCode: /multilingual\W\d+\W\.address.countryCode/,
  cntCode: /^countryCode$/,
  sortAlias: /multilingual\W\d+\W\.sortAlias/,
  standReference: /stands(\W\d+\W)?/,
  packageId: /packageId/,
  exhibitorTypeId: /exhibitorTypeId/,
  companyName: /companyName/,
  isPublished: /isPublished/,
  website: /website/,
  socialMediaUrl: /socialMediaUrl/,
  primaryAdministratorFirstName: /primaryAdministratorFirstName/,
  primaryAdministratorLastName: /primaryAdministratorLastName/,
  primaryAdministratorEmail: /primaryAdministratorEmail/,
  administratorEmail: /administratorEmail/,
  administratorFirstName: /administratorFirstName/,
  administratorLastName: /administratorLastName/,
  representedBrands: /multilingual\W\d+\W\.representedBrands(\W\d+\W)?/,
  profileQuestions: /profileQuestions(\W\d+\W)?/,
  filterCategories: /filterCategories(\W\d+\W)?/,
  companyObjectives: /companyObjectives(\W\d+\W)?/
};

const ProductFieldErrorSelectors = {
  file: /\bfile/,
  productImage: /productImage/,
  imageUrl: /imageUrl/,
  video: /videoId/,
  attribute: /attributes\W\d+\W\.value/,
  title: /multilingual\W\d+\W\.product.title/,
  productTitle: /productTitle|multilingual\W\d+\W\.product_title/,
  productDescription: 'description',
  description: /multilingual\W\d+\W\.description/
};

const SessionFieldErrorSelectors = {
  title: /title/,
  sessionDate: /sessionDate/,
  startTime: /start/,
  endTime: /end/,
  location: /location/,
  speakerName: /speakerName/,
  description: /description/,
  sessionSpeakers: /sessionSpeakers(\W\d+\W)?/
};

const SessionStorageKeys = {
  isPrimaryEventEdition: 'isPrimaryEventEdition'
};

const FieldValidationErrorCodes = {
  invalidFileSize: 'invalid_file_size',
  invalidFileSizeOneMb: 'invalid_file_size_one_mb',
  invalidFileNameSize: 'invalid_file_name_size',
  invalidFileNameSizeInBytes: 'invalid_file_name_size_in_bytes',
  invalidFileFormat: 'invalid_file_format',
  invalidVideoFileDuration: 'invalid_video_file_duration',
};

const DirectoryDescriptionTrimmedLengths = {
  bronze: 150,
  silver: 300,
  gold: 300
};

const DirectoryDescriptionTrimmedLengthsPackageRedesignFeatureToggle = {
  gold: 150
};

const DirectoryObjectiveTrimmedLengths = {
  gold: 200
};

const DirectoryObjectiveTrimmedLengthsPackageRedesignFeatureToggle = {
  gold: 150
};

const SecondaryAdminFieldNames = {
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  jobTitles: 'jobTitles',
  exhibitorAdmin: 'exhibitorAdmin',
  restrictParticipantShow: 'not',
  twoFactorAuth: '2SV'
};

const FavouriteConstants = {
  sourceDirectory: 'ExhibitorDirectory',
  sourceDetails: 'ExhibitorDetails',
  exhibitorFavourite: 'ExhibitorFavourite',
  exhibitorUnfavourite: 'ExhibitorUnFavourite',
  sourceDirectoryProduct: 'ProductDirectory',
  productFavourite: 'ProductFavourite',
  productUnfavourite: 'ProductUnFavourite',
  favouriteIconSelected: 'M1495,495.398438 C1495,498.679688 1491.9308,501.427734 ' +
  '1491.80525,501.550781 L1483.11384,509.753906 C1482.94643,509.917969 1482.72321,510 ' +
  '1482.5,510 C1482.27679,510 1482.05357,509.917969 1481.88616,509.753906 L1473.1808, ' +
  '501.523438 C1473.0692,501.427734 1470,498.679688 1470,495.398438 C1470,491.392578 ' +
  '1472.49721,489 1476.66853,489 C1479.10993,489 1481.39788,490.886719 1482.5,491.953125 ' +
  'C1483.60212,490.886719 1485.89007,489 1488.33147,489 C1492.50279,489 1495,491.392578 1495, ' +
  '495.398438 Z',
  favouriteIconUnSelectedPath1: 'M23.2142857,6.3984375 C23.2142857,' +
  '2.55664062 20.5636161,1.75 18.3314732,1.75 C16.2527902,1.75 13.9090402,' +
  '3.95117188 13.1835938,4.79882812 C12.8487723,5.1953125 12.1512277,' +
  '5.1953125 11.8164063,4.79882812 C11.0909598,3.95117188 8.74720982,1.75 ' +
  '6.66852679,1.75 C4.43638393,1.75 1.78571429,2.55664062 1.78571429,6.3984375 C1.78571429,' +
  '8.90039062 4.36662946,11.2246094 4.39453125,11.2519531 L12.5,18.9082031 L20.5915179,' +
  '11.265625 C20.6333705,11.2246094 23.2142857,8.90039062 23.2142857,6.3984375 Z M25,' +
  '6.3984375 C25,9.6796875 21.9308036,12.4277344 21.8052455,12.5507812 L13.1138393,20.7539062 ' +
  'C12.9464286,20.9179688 12.7232143,21 12.5,21 C12.2767857,21 12.0535714,20.9179688 ' +
  '11.8861607,20.7539062 L3.18080357,12.5234375 C3.06919643,12.4277344 0,9.6796875 0,6.3984375 ' +
  'C0,2.39257812 2.49720982,0 6.66852679,0 C9.10993304,0 11.3978795,1.88671875 12.5,2.953125 ' +
  'C13.6021205,1.88671875 15.890067,0 18.3314732,0 C22.5027902,0 25,2.39257812 25,6.3984375 Z',
  favouriteIconUnSelectedPath2: 'M23.2142857,6.3984375 C23.2142857,2.55664062 ' +
  '20.5636161,1.75 18.3314732,1.75 C16.2527902,1.75 13.9090402,3.95117188 13.1835937,' +
  '4.79882812 C12.8487723,5.1953125 12.1512277,5.1953125 11.8164062,4.79882812 ' +
  'C11.0909598,3.95117188 8.74720982,1.75 6.66852679,1.75 C4.43638393,1.75 1.78571429,' +
  '2.55664062 1.78571429,6.3984375 C1.78571429,8.90039062 4.36662946,11.2246094 4.39453125,' +
  '11.2519531 L12.5,18.9082031 L20.5915179,11.265625 C20.6333705,11.2246094 23.2142857,' +
  '8.90039062 23.2142857,6.3984375 Z'
};

const FollowConstants = {
  followIcon: 'M40.4106807,65.8649987 L40.3919325,65.8649987 C42.6345518,63.8014644 ' +
      '44.0526316,60.8233607 44.0526316,57.4999223 C44.0526316,54.1765616 42.6345518,51.1985356 40.3919325,' +
      '49.1350013 L40.4106807,49.1350013 C33.4824611,42.7481751 34.4136976,37.8822364 38.9780444,' +
      '32.7301255 L38.9656218,32.7301255 C40.2613049,31.2715878 41.0574172,29.3426268 41.0574172,27.2192304 ' +
      'C41.0574172,22.6798904 37.4499904,19 32.9999619,19 C28.5500096,19 24.9425828,22.6798904 24.9425828,27.2192304 ' +
      'C24.9425828,29.3426268 25.7386951,31.2715878 27.034302,32.7301255 L27.0219556,32.7301255 C31.5863024,37.8822364 ' +
      '32.5174627,42.7481751 25.5893193,49.1350013 L25.6080675,49.1350013 C23.3654482,51.1985356 21.9473684,54.1765616 ' +
      '21.9473684,57.4999223 C21.9473684,60.8233607 23.3654482,63.8014644 25.6080675,65.8649987 L25.5893193,65.8649987 ' +
      'C32.5174627,72.2516695 31.5863024,77.1177636 27.0219556,82.2697967 L27.034302,82.2697967 C25.7386951,83.7284122 ' +
      '24.9425828,85.6572954 24.9425828,87.7806919 C24.9425828,92.3201096 28.5500096,96 32.9999619,96 C37.4499904,96 ' +
      '41.0574172,92.3201096 41.0574172,87.7806919 C41.0574172,85.6572954 40.2613049,83.7284122 38.9656218,82.2697967 ' +
      'L38.9780444,82.2697967 C34.4136976,77.1177636 33.4825373,72.2516695 40.4106807,65.8649987 Z M13.2727236,57.5 C13.0344396,' +
      '54.6004839 14.3871552,51.8906707 16.7520741,49.1009323 L16.7399769,49.1009323 C18.0094313,47.6073508 18.7894737,45.6323077 ' +
      '18.7894737,43.458009 C18.7894737,38.8097718 15.2548646,35.0416667 10.8947368,35.0416667 C6.53453439,35.0416667 ' +
      '3,38.8097718 3,43.458009 C3,45.6323077 3.78011706,47.6073508 5.04949677,49.1009323 L5.03739962,49.1009323 ' +
      'C7.40231847,51.8906707 8.75503413,54.6004839 8.51675008,57.5 C8.75503413,60.3995161 7.40231847,63.1093293 ' +
      '5.03739962,65.8990677 L5.04949677,65.8990677 C3.78011706,67.3925696 3,69.3676923 3,71.541991 C3,76.1902282 6.53453439,' +
      '79.9583333 10.8947368,79.9583333 C15.2548646,79.9583333 18.7894737,76.1902282 18.7894737,71.541991 C18.7894737,69.3676923 ' +
      '18.0094313,67.3925696 16.7399769,65.8990677 L16.7520741,65.8990677 C14.3871552,63.1093293 13.0344396,60.3995161 13.2727236,' +
      '57.5 Z M57.4832499,57.5 C57.2449659,54.6004839 58.5976815,51.8906707 60.9625257,49.1009323 L60.9504286,49.1009323 C62.2199576,' +
      '47.6073508 63,45.6323077 63,43.458009 C63,38.8097718 59.4653909,35.0416667 55.1052632,35.0416667 C50.7450607,35.0416667 47.2105263,' +
      '38.8097718 47.2105263,43.458009 C47.2105263,45.6323077 47.9906434,47.6073508 49.2600231,49.1009323 L49.2479259,49.1009323 ' +
      'C51.6128448,51.8906707 52.9655604,54.6004839 52.7272764,57.5 C52.9655604,60.3995161 51.6128448,63.1093293 49.2479259,65.8990677 ' +
      'L49.2600231,65.8990677 C47.9906434,67.3925696 47.2105263,69.3676923 47.2105263,71.541991 C47.2105263,76.1902282 50.7450607,' +
      '79.9583333 55.1052632,79.9583333 C59.4653909,79.9583333 63,76.1902282 63,71.541991 C63,69.3676923 62.2199576,67.3925696 60.9504286,' +
      '65.8990677 L60.9625257,65.8990677 C58.5976815,63.1093293 57.2449659,60.3995161 57.4832499,57.5 Z',
  followIconUnselected: 'M82,6 C90.2868542,6 97,12.7131458 97,21 C97,29.2868542 90.2868542,36 82,36 C73.7131458,36 67,29.2868542 ' +
      '67,21 C67,12.7131458 73.7131458,6 82,6 Z M84,11 L80,11 L80,18.89 L71.2857143,18.8901099 L71.2857143,23.1098901 L80,23.109 L80,' +
      '32 L84,32 L84,23.109 L92.7142857,23.1098901 L92.7142857,18.8901099 L84,18.89 L84,11 Z',
  followIconSelected: 'M82,6 C90.2868542,6 97,12.7131458 97,21 C97,29.2868542 90.2868542,36 82,36 C73.7131458,36 67,29.2868542 ' +
      '67,21 C67,12.7131458 73.7131458,6 82,6 Z M92.7142857,18.8901099 L71.2857143,18.8901099 L71.2857143,23.1098901 L92.7142857,' +
      '23.1098901 L92.7142857,18.8901099 Z'
};

const DiscoverConstants = {
  noImagePlaceHolderSrc: 'data:image/svg+xml;base64,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'
}

const TestVariantKeys = {
  productGallery: 'product-gallery',
  productTags: 'product-tags'
};

const ImageFileExtensions = ['jpeg', 'jpg', 'png'];
const VideoFileExtensions = ['.mp4','.avi'];
const DocumentFileExtensions = ['pdf'];
const CertificateFileExtension = 'cer';
const MaxMobileScreenWidth = 420;
const MaxFileNameSize = 255;
const MaxFileNameSizeInBytes = 255;

const oneMegabyte = 1048576;
const twentyFiveMegabyte = 25 * oneMegabyte;
const maxVideoFileDurationInSeconds = 5 * 60;
const maxVideoFileNameLength = 80;
const fiveMegabyte = 5 * oneMegabyte;
const filtersAlgoliaPrefix = 'filters.';
const maxFilterItems = 100;

const itemsPerPage = 100;
const SocialMediaKeys = [
  'FACEBOOK',
  'TWITTER',
  'YOUTUBE',
  'LINKEDIN',
  'WECHAT',
  'INSTAGRAM'
];

const Tenants = {
  artists: 'artists',
  participants: 'participants',
  exhibitor: 'exhibitors'
}
const SocialMediaLogoViewBox = {
  FACEBOOK: '0 0 14 14',
  TWITTER: '0 0 1200 1227',
  YOUTUBE: '0 0 14 14',
  LINKEDIN: '0 0 14 14',
  WECHAT: '0 0 14 14',
  INSTAGRAM: '0 0 14 14'
}
const SocialMediaConstants = {
  facebookPath: 'M711.3,660,734,512H592V416c0-40.49,19.84-80,83.44-80H740V210s-58.59-10-114.61-10C508.44,200,432,,' +
    '270.88,432,399.2V512H302V660H432v357.78a517.58,517.58,0,0,0,160,0V660Z',
  FACEBOOK: 'M7,0.4c-3.6,0-6.6,3-6.6,6.6c0,3.3,2.4,6,5.6,6.5V8.9H4.3V7H6V5.6C6,3.9,7,3,8.5,3C9.2,3,10,3.1,10,' +
    '3.1v1.6H9.1c-0.8,0-1.1,0.5-1.1,1V7h1.8L9.6,8.9H8.1v4.6c3.2-0.5,5.6-3.2,5.6-6.5C13.6,3.4,10.7,0.4,7,0.4z',
  TWITTER: 'M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z',
  YOUTUBE: 'M13.37,4.14a10,10,0,0,1,.23,1.92l0,' +
    '1.17,0,1.17a10.24,10.24,0,0,1-.23,1.95,1.69,' +
    '1.69,0,0,1-.42.7,1.73,1.73,0,0,1-.73.42,16.65,16.65,0,0,1-2.86.24l-2.13,' +
    '0-2.13,0a16.65,16.65,0,0,1-2.86-.24,1.65,1.65,0,0,' +
    '1-1.15-1.12A10.94,10.94,0,0,1,.85,8.4l0-1.17c0-.34,0-.73,' +
    '0-1.17a10.66,10.66,0,0,1,.24-1.92,1.62,1.62,0,0,1,.42-.73A1.67,1.67,' +
    '0,0,1,2.24,3,16.65,16.65,0,0,1,5.1,2.75l2.13,0,2.13,0A16.65,16.65,0,0,1,12.22,' +
    '3a1.73,1.73,0,0,1,.73.42A1.62,1.62,0,0,1,13.37,4.14Zm-7.45,5L9.27,7.23,5.92,5.33Z',
  LINKEDIN: 'M11.73,2a.73.73,0,0,1,.53.22.77.77,0,0,1,.22.53v9a.75.75,0,0,' +
    '1-.75.75h-9a.77.77,0,0,1-.53-.22A.73.73,0,0,1,2,11.73v-9A.75.75,0,0,1,2.73,' +
    '2ZM4.37,5.28A.89.89,0,0,0,5,3.75a.87.87,0,0,0-.64-.27.83.83,0,0,0-.63.27A.89.89,' +
    '0,0,0,3.74,5,.83.83,0,0,0,4.37,5.28ZM5.14,11h0V6H3.6v5ZM11,11V8.24a3.39,3.39,0,0,' +
    '0-.33-1.71,1.66,1.66,0,0,0-1.52-.68,1.81,1.81,0,0,0-1,.25,1.34,1.34,0,0,' +
    '0-.52.54h0V6H6.13v5H7.67V8.49a1.92,1.92,0,0,1,.17-.89.82.82,0,0,' +
    '1,.77-.39.67.67,0,0,1,.71.44,2.76,2.76,0,0,1,.11.89V11Z',
  WECHAT: 'M9.5,5.17a4,4,0,0,0-1.94.48A3.64,3.64,0,0,0,6.15,7a3.4,3.4,0,0,0-.51,' +
    '1.82,3,3,0,0,0,.14.93l-.43,0A7.48,7.48,0,0,1,4,9.57L3.76,9.5l-1.59.82.44-1.38A3.73,' +
    '3.73,0,0,1,.78,5.85,3.43,3.43,0,0,1,1.39,3.9,4.19,4.19,0,0,1,3.06,2.5,5.06,5.06,0,0,' +
    '1,5.35,2a5.27,5.27,0,0,1,2.09.42A4.7,4.7,0,0,1,9.09,3.55,3.39,3.39,0,0,1,10,5.19,3.24,' +
    '3.24,0,0,0,9.5,5.17ZM3.85,5.05a.61.61,0,0,0,.43-.15.53.53,0,0,0,.16-.41.53.53,0,0,' +
    '0-.16-.41.61.61,0,0,0-.43-.16.78.78,0,0,0-.46.16.49.49,0,0,0,0,.82A.77.77,0,0,0,3.85,' +
    '5.05Zm9.82,3.66a2.64,2.64,0,0,1-.44,1.45,4.7,4.7,0,0,1-1.15,1.17l.35,1.15-1.26-.68-.07,' +
    '0A6.13,6.13,0,0,1,9.81,12a4.29,4.29,0,0,1-2-.44,3.63,3.63,0,0,1-1.41-1.21,2.93,2.93,0,0,' +
    '1-.51-1.66,3,3,0,0,1,.51-1.67,3.61,3.61,0,0,1,1.41-1.2,4.29,4.29,0,0,1,2-.45,4.18,4.18,0,' +
    '0,1,1.9.45,3.82,3.82,0,0,1,1.43,1.2A2.87,2.87,0,0,1,13.67,8.71ZM7.07,3.92a.85.85,0,0,' +
    '0-.5.16.51.51,0,0,0,0,.82.81.81,0,0,0,.48.15.61.61,0,0,0,.43-.15.56.56,0,0,0,.15-.41.56.56,' +
    '0,0,0-.15-.41A.58.58,0,0,0,7.07,3.92ZM8.54,8.14A.55.55,0,0,0,9,8a.42.42,0,0,0,.15-.31A.42.42,' +
    '0,0,0,9,7.37a.6.6,0,0,0-.41-.14.42.42,0,0,0-.3.14.41.41,0,0,0-.14.32A.41.41,0,0,0,8.24,8,' +
    '.39.39,0,0,0,8.54,8.14Zm2.51,0A.55.55,0,0,0,11.46,8a.42.42,0,0,0,.15-.31.4.4,0,0,' +
    '0-.16-.32.61.61,0,0,0-.4-.14.46.46,0,0,0-.31.14.45.45,0,0,0-.14.32.44.44,0,0,0,' +
    '.14.31A.42.42,0,0,0,11.05,8.14Z',
  INSTAGRAM: 'M12.46,5.05c0,.44,0,1.16,0,2.18s0,1.75,0,2.19a4.24,' +
    '4.24,0,0,1-.2,1.16,2.7,2.7,0,0,1-1.66,1.66,4.24,4.24,0,0,1-1.16.2c-.44,0-1.18,0-2.19,0s-1.75,0-2.19,0a3.57,' +
    '3.57,0,0,1-1.16-.22,2.45,2.45,0,0,1-1-.62,2.74,2.74,0,0,1-.65-1A4.65,4.65,0,0,1,2,9.42C2,9,2,8.24,2,7.23S2,' +
    '5.48,2,5a4.65,4.65,0,0,1,.2-1.16A2.8,2.8,0,0,1,3.88,2.21,4.65,4.65,0,0,1,5,2Q5.7,2,7.23,2C8.24,2,9,2,9.42,' +
    '2a4.65,4.65,0,0,1,1.16.2,2.75,2.75,0,0,1,1.66,1.67A5.19,5.19,0,0,1,12.46,5.05Zm-1.13,5.27a4.91,4.91,0,0,' +
    '0,.19-1.26c0-.35,0-.83,0-1.46V6.85c0-.64,0-1.12,0-1.45a4.76,4.76,0,0,0-.19-1.26,1.68,1.68,0,0,0-1-1,4.37,' +
    '4.37,0,0,0-1.26-.19c-.35,0-.83,0-1.46,0H6.85c-.62,0-1.11,0-1.45,0a4.5,4.5,0,0,0-1.26.19,1.68,1.68,0,0,0-1,' +
    '1A4.37,4.37,0,0,0,2.94,5.4c0,.35,0,.83,0,1.45V7.6c0,.63,0,1.11,0,1.46a4.5,4.5,0,0,0,.19,1.26,1.76,1.76,0,0,0,' +
    '1,1,4.91,4.91,0,0,0,1.26.19l1.45,0H7.6l1.46,0a4.76,4.76,0,0,0,1.26-.19A1.76,1.76,0,0,0,11.33,10.32ZM7.23,' +
    '4.53a2.7,2.7,0,1,1,0,5.39,2.65,2.65,0,0,1-1.35-.36,2.71,2.71,0,0,1-1-1,2.65,2.65,0,0,1,0-2.7,2.71,2.71,0,0,' +
    '1,1-1A2.66,2.66,0,0,1,7.23,4.53ZM7.23,9a1.71,1.71,0,0,0,1.24-.52A1.74,1.74,0,0,0,8.47,6,1.74,1.74,0,0,0,6,6,' +
    '1.74,1.74,0,0,0,6,8.47,1.69,1.69,0,0,0,7.23,9Zm3.44-4.57A.64.64,0,0,0,10.49,4,.65.65,0,0,0,10,3.78a.65.65,0,' +
    '0,0-.63.64.62.62,0,0,0,1.07.44A.71.71,0,0,0,10.67,4.42Z'
};
const Sections = {
  IMAGES: 'IMAGES',
  BASIC_INFORMATION: 'BASIC_INFORMATION',
  STANDS: 'STANDS',
  REPRESENTED_BRANDS: 'REPRESENTED_BRANDS',
  FILTERS: 'FILTERS',
  FILTER_CATEGORIES: 'FILTER CATEGORIES',
  MATCHMAKING: 'MATCHMAKING',
  PRODUCTS: 'PRODUCTS',
  SESSIONS: 'SESSIONS',
  EXTERNAL_LINKS: 'EXTERNAL_LINKS',
  CONTACT_US: 'CONTACT_US',
  SETTINGS: 'SETTINGS',
  DOCUMENTS: 'DOCUMENTS',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  NONE: 'NONE',
  SPONSORED_CATEGORIES: 'SPONSORED_CATEGORIES',
  COMPANY_OBJECTIVES: 'COMPANY_OBJECTIVES',
};
const ManageThirdPartyFieldNames = {
  name: 'Name',
  ssoLoginURL: 'SSOLoginURL',
  entitlementCodes: 'ProductCodes',
  relayState: 'RelayState'
};
const PpsTags = {
  exhibitor: 'Exhibitor',
  filters: 'Filters',
  matchmaking: 'MatchMaking'
};
const CompanyNameAideEnabledBUs = ['OBU_018'];
const EmailRegexPattern = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;
const EventFormCode = {
  'eve-7754f35c-8c9e-45ef-a1c3-dbd2da9b8014': {
    default: '5f1f9fd3-2ae4-4fe8-becc-91a3cefb6331'
  },
  'eve-52920408-aa70-4f3f-a15b-ccf23b7e3b95': {
    default: 'e107563f-58bb-403b-9700-a73aa0e6a27a'
  },
  'eve-82c61776-434d-40b3-80a9-beafa091cb73': {
    default: '181c263c-f740-45d6-a172-313168ff0beb'
  },
  'eve-f62e5f66-c389-4650-bb57-62a8954f0352': {
    default: 'fb99b97b-e862-489e-9523-5eac08f27a65'
  },
  'eve-ab0fc4cc-2196-4eb3-821a-d3563606e55c': {
    default: '6655c441-f3b0-4582-a841-8743c2e26441'
  },
  'eve-e638a0a3-b1d3-4b64-9e3f-e0b870f71e02': {
    default: '8ab12204-5ee0-491d-9022-531e5741e06f'
  },
  'eve-0797982d-d456-4d3b-b1cb-02f037b8e8b9': {
    default: 'f28b2274-6419-4ea6-bd3c-392d394a7d9f'
  },
  'eve-e0bf2b66-dbc2-4805-864d-3be93a0fcc52': {
    default: '10188cff-ead8-4a44-8cf2-183d74180a97'
  },
  'eve-f02e4ae4-a985-4ffe-bde8-f82ca0ca2603': {
    default: 'bf40d932-3d8c-4066-9667-bdd5c05320ef'
  }
};

const DataDtmActions = {
  view: 'view',
  click: 'click'
};

const RegRedirectConstants = {
  LOGIN_EMAIL_PATH: 'secure/Account/LoginEmail',
  ATLAS20SHOW: 'Atlas2.0',
  REDIRECT_URL: 'redirectUrl',
  PRODUCT_TYPE: 'productType',
  REG_REDIRECT_URL_DEV: 'https://showcase-ui-dev.css.rxweb-dev.com/component/regRedirectComponent',
  PKCE_REDIRECT_URL_DEV: 'https://showcase-ui-dev.css.rxweb-dev.com/component/pkceSignupRedirectComponent',
  REG_REDIRECT_URL: '/reg-redirect',
  PKCE_SIGNUP_REDIRECT_URL: '/pkce-signup'
};
const Claims = {
  EventEditionClaim: 'rxAtlasEe',
  RoleClaim:'role',
  BuIdClaim:'rxBu',
  ParticipantClaim:'rxParticipant'
};
const Roles = {
  buAdmin :'urn:rxrole:bu'
}

const ReactSettings = {
  productsDirectory: 'reactSettingsProductsDirectory',
  exhibitorHub: 'reactSettingsExhibitorHub',
  taskList: 'reactSettingsTasklist',
  productDetails: 'reactSettingsProductDetails',
  artistsDirectory: 'reactSettingsArtistsDirectory',
  artistsDetails: 'reactSettingsArtistDetails',
  ManageAdminRoles: 'reactSettingsManageAdminRoles',
  default: 'reactSettings',
  mixpanel: 'reactSettingsMixpanel',
  exhibitorHubOperationalTasks: 'reactSettingsExhibitorHubOperationalTasks'
};

const CallToActionConstants = {
  localStorageKey: 'cta',
  localStorageProductKey: 'cta_products',
  // eslint-disable-next-line max-len
  addressLightIcon: 'M29.9374525,25 C30.5103675,25 30.997346,24.7994794 31.3983865,24.3984389 C31.799427,23.9973984 ' +
  '31.9999475,23.51042 31.9999475,22.9375049 L31.9999475,22.9375049 L31.9999475,10.5625344 C31.9999475,9.98961934 31.799427,9.5026409 ' +
  '31.3983865,9.1016004 C30.997346,8.70055991 30.5103675,8.50003934 29.9374525,8.50003934 L29.9374525,8.50003934 L12.0624951,8.50003934 ' +
  'C11.48958,8.50003934 11.0026016,8.70055991 10.6015611,9.1016004 C10.2005206,9.5026409 10,9.98961934 10,10.5625344 L10,10.5625344 L10,22.9375049 ' +
  'C10,23.51042 10.2005206,23.9973984 10.6015611,24.3984389 C11.0026016,24.7994794 11.48958,25 12.0624951,25 L12.0624951,25 L29.9374525,25 ' +
  'Z M29.9374525,23.6250033' +
  ' L12.0624951,23.6250033 C11.8619745,23.6250033 11.6972616,23.5605503 11.5683556,23.4316444 C11.4394497,23.3027384 11.3749967,23.1380255 ' +
  '11.3749967,22.9375049 L11.3749967,22.9375049 L11.3749967,10.5625344 C11.3749967,10.3620138 11.4394497,10.1973009 11.5683556,10.068395 ' +
  'C11.6972616,9.93948903 11.8619745,9.87503606 12.0624951,9.87503606 L12.0624951,9.87503606 L29.9374525,9.87503606 C30.137973,9.87503606 ' +
  '30.302686,9.93948903 30.4315919,10.068395 C30.5604979,10.1973009 30.6249508,10.3620138 30.6249508,10.5625344 L30.6249508,10.5625344 ' +
  'L30.6249508,22.9375049 C30.6249508,23.1380255 30.5604979,23.3027384 30.4315919,23.4316444 C30.302686,23.5605503 30.137973,23.6250033 ' +
  '29.9374525,23.6250033 L29.9374525,23.6250033 Z M20.48435,22.2500066 C20.9999738,22.2500066 21.4439829,22.0638093 21.8163781,21.6914141 ' +
  'C22.1887732,21.319019 22.3749705,20.8750098 22.3749705,20.3593861 L22.3749705,20.3593861 L22.3749705,19.757825 C22.3749705,19.2135552 ' +
  '22.2317419,18.6836088 21.945284,18.167985 C21.5442435,17.5091327 20.9713278,17.0651229 20.2265381,16.835957 C20.7421619,16.2057499 ' +
  '20.9999738,15.4896062 20.9999738,14.6875246 C20.9999738,13.7422143 20.6633863,12.9329717 19.9902106,12.259796 C19.3170349,11.5866203 ' +
  '18.5077922,11.2500328 17.562482,11.2500328 C16.6171717,11.2500328 15.8079291,11.5866203 15.1347534,12.259796 C14.4615777,12.9329717 ' +
  '14.1249902,13.7422143 14.1249902,14.6875246 C14.1249902,15.4896062 14.3828021,16.2057499 14.8984258,16.835957 C14.1536361,17.0651229 ' +
  '13.5807204,17.5091327 13.1796799,18.167985 C12.8932221,18.6836088 12.7499934,19.2135552 12.7499934,19.757825 L12.7499934,19.757825 ' +
  'L12.7499934,20.3593861 C12.7499934,20.8750098 12.9361907,21.319019 13.3085859,21.6914141 C13.680981,22.0638093 14.1249902,22.2500066 ' +
  '14.6406139,22.2500066 L14.6406139,22.2500066 L20.48435,22.2500066 Z M28.7343303,14.0000262 C28.8775589,14.0000262 28.9993039,13.9498959 ' +
  '29.0995638,13.849636 C29.1998238,13.749376 29.2499541,13.6276311 29.2499541,13.4844025 L29.2499541,13.4844025 L29.2499541,13.1406533 ' +
  'C29.2499541,12.9974247 29.1998238,12.8756797 29.0995638,12.7754198 C28.9993039,12.6751598 28.8775589,12.6250295 28.7343303,12.6250295 ' +
  'L28.7343303,12.6250295 L24.265591,12.6250295 C24.1223624,12.6250295 24.0006174,12.6751598 23.9003575,12.7754198 C23.8000975,12.8756797 ' +
  '23.7499672,12.9974247 23.7499672,13.1406533 L23.7499672,13.1406533 L23.7499672,13.4844025 C23.7499672,13.6276311 23.8000975,13.749376 ' +
  '23.9003575,13.849636 C24.0006174,13.9498959 24.1223624,14.0000262 24.265591,14.0000262 L24.265591,14.0000262 L28.7343303,14.0000262 ' +
  'Z M17.562482,16.7500197 C16.9895669,16.7500197 16.5025884,16.5494991 16.101548,16.1484586 C15.7005075,15.7474181 15.4999869,15.2604397 ' +
  '15.4999869,14.6875246 C15.4999869,14.1146095 15.7005075,13.6276311 16.101548,13.2265906 C16.5025884,12.8255501 16.9895669,12.6250295 ' +
  '17.562482,12.6250295 C18.1353971,12.6250295 18.6223755,12.8255501 19.023416,13.2265906 C19.4244565,13.6276311 19.6249771,14.1146095 ' +
  '19.6249771,14.6875246 C19.6249771,15.2604397 19.4244565,15.7474181 19.023416,16.1484586 C18.6223755,16.5494991 18.1353971,16.7500197 ' +
  '17.562482,16.7500197 Z M28.7343303,16.7500197 C28.8775589,16.7500197 28.9993039,16.6998894 29.0995638,16.5996294 C29.1998238,16.4993694 ' +
  '29.2499541,16.3776245 29.2499541,16.2343959 L29.2499541,16.2343959 L29.2499541,15.8906467 C29.2499541,15.7474181 29.1998238,15.6256732 ' +
  '29.0995638,15.5254132 C28.9993039,15.4251533 28.8775589,15.3750229 28.7343303,15.3750229 L28.7343303,15.3750229 L24.265591,15.3750229 ' +
  'C24.1223624,15.3750229 24.0006174,15.4251533 23.9003575,15.5254132 C23.8000975,15.6256732 23.7499672,15.7474181 23.7499672,15.8906467 ' +
  'L23.7499672,15.8906467 L23.7499672,16.2343959 C23.7499672,16.3776245 23.8000975,16.4993694 23.9003575,16.5996294 C24.0006174,16.6998894 ' +
  '24.1223624,16.7500197 24.265591,16.7500197 L24.265591,16.7500197 L28.7343303,16.7500197 Z M20.48435,20.8750098 L14.6406139,20.8750098 ' +
  'C14.4973853,20.8750098 14.3756404,20.8248795 14.2753804,20.7246196 C14.1751205,20.6243596 14.1249902,20.5026147 14.1249902,20.3593861 ' +
  'L14.1249902,20.3593861 L14.1249902,19.757825 C14.1249902,19.3854298 14.2395734,19.0488423 14.4687393,18.7480618 C14.6979052,18.4472812 ' +
  '14.9986858,18.2395997 15.3710809,18.1250164 L15.3710809,18.1250164 L16.2734225,17.8672045 C16.674463,18.0390791 17.1041495,18.1250164 ' +
  '17.562482,18.1250164 C18.0208144,18.1250164 18.4505009,18.0390791 18.8515414,17.8672045 L18.8515414,17.8672045 L19.753883,18.1250164 ' +
  'C20.1262782,18.2395997 20.4270587,18.4472812 20.6562246,18.7480618 C20.8853905,19.0488423 20.9999738,19.3854298 20.9999738,19.757825 ' +
  'L20.9999738,19.757825 L20.9999738,20.3593861 C20.9999738,20.5026147 20.9498435,20.6243596 20.8495835,20.7246196 C20.7493235,20.8248795 ' +
  '20.6275786,20.8750098 20.48435,20.8750098 L20.48435,20.8750098 Z M28.7343303,19.5000131 C28.8775589,19.5000131 28.9993039,19.4498828 ' +
  '29.0995638,19.3496228 C29.1998238,19.2493629 29.2499541,19.1276179 29.2499541,18.9843893 L29.2499541,18.9843893 L29.2499541,18.6406402 ' +
  'C29.2499541,18.4974116 29.1998238,18.3756666 29.0995638,18.2754067 C28.9993039,18.1751467 28.8775589,18.1250164 28.7343303,18.1250164 ' +
  'L28.7343303,18.1250164 L24.265591,18.1250164 C24.1223624,18.1250164 24.0006174,18.1751467 23.9003575,18.2754067 C23.8000975,18.3756666 ' +
  '23.7499672,18.4974116 23.7499672,18.6406402 L23.7499672,18.6406402 L23.7499672,18.9843893 C23.7499672,19.1276179 23.8000975,19.2493629 ' +
  '23.9003575,19.3496228 C24.0006174,19.4498828 24.1223624,19.5000131 24.265591,19.5000131 L24.265591,19.5000131 L28.7343303,19.5000131 Z',

  addressSolidIcon: 'M29.9374525,26 C30.5103675,26 30.997346,25.7994794 31.3983865,25.3984389 C31.799427,24.9973984 ' +
  '31.9999475,24.51042 31.9999475,23.9375049 L31.9999475,23.9375049 L31.9999475,11.5625344 C31.9999475,10.9896193 ' +
  '31.799427,10.5026409 31.3983865,10.1016004 C30.997346,9.70055991 30.5103675,9.50003934 29.9374525,9.50003934 ' +
  'L29.9374525,9.50003934 L12.0624951,9.50003934 C11.48958,9.50003934 11.0026016,9.70055991 10.6015611,10.1016004 ' +
  'C10.2005206,10.5026409 10,10.9896193 10,11.5625344 L10,11.5625344 L10,23.9375049 C10,24.51042 10.2005206,24.9973984 ' +
  '10.6015611,25.3984389 C11.0026016,25.7994794 11.48958,26 12.0624951,26 L12.0624951,26 L29.9374525,26 Z ' +
  'M17.562482,18.9531418 C16.731755,18.9531418 16.0227723,18.6595229 15.4355339,18.0722845 C14.8482955,17.4850461 ' +
  '14.5546766,16.7760634 14.5546766,15.9453365 C14.5546766,15.1146095 14.8482955,14.4056268 15.4355339,13.8183884 ' +
  'C16.0227723,13.23115 16.731755,12.9375311 17.562482,12.9375311 C18.3932089,12.9375311 19.1021916,13.23115 19.68943,13.8183884 ' +
  'C20.2766684,14.4056268 20.5702873,15.1146095 20.5702873,15.9453365 C20.5702873,16.7760634 20.2766684,17.4850461 ' +
  '19.68943,18.0722845 C19.1021916,18.6595229 18.3932089,18.9531418 17.562482,18.9531418 Z M28.7343303,15.0000262 ' +
  'L24.265591,15.0000262 C24.1223624,15.0000262 24.0006174,14.9498959 23.9003575,14.849636 C23.8000975,14.749376 ' +
  '23.7499672,14.6276311 23.7499672,14.4844025 L23.7499672,14.4844025 L23.7499672,14.1406533 C23.7499672,13.9974247 ' +
  '23.8000975,13.8756797 23.9003575,13.7754198 C24.0006174,13.6751598 24.1223624,13.6250295 24.265591,13.6250295 ' +
  'L24.265591,13.6250295 L28.7343303,13.6250295 C28.8775589,13.6250295 28.9993039,13.6751598 29.0995638,13.7754198 ' +
  'C29.1998238,13.8756797 29.2499541,13.9974247 29.2499541,14.1406533 L29.2499541,14.1406533 L29.2499541,14.4844025 ' +
  'C29.2499541,14.6276311 29.1998238,14.749376 29.0995638,14.849636 C28.9993039,14.9498959 28.8775589,15.0000262 ' +
  '28.7343303,15.0000262 L28.7343303,15.0000262 Z M28.7343303,17.7500197 L24.265591,17.7500197 C24.1223624,17.7500197 ' +
  '24.0006174,17.6998894 23.9003575,17.5996294 C23.8000975,17.4993694 23.7499672,17.3776245 23.7499672,17.2343959 ' +
  'L23.7499672,17.2343959 L23.7499672,16.8906467 C23.7499672,16.7474181 23.8000975,16.6256732 23.9003575,16.5254132 ' +
  'C24.0006174,16.4251533 24.1223624,16.3750229 24.265591,16.3750229 L24.265591,16.3750229 L28.7343303,16.3750229 ' +
  'C28.8775589,16.3750229 28.9993039,16.4251533 29.0995638,16.5254132 C29.1998238,16.6256732 29.2499541,16.7474181 ' +
  '29.2499541,16.8906467 L29.2499541,16.8906467 L29.2499541,17.2343959 C29.2499541,17.3776245 29.1998238,17.4993694 ' +
  '29.0995638,17.5996294 C28.9993039,17.6998894 28.8775589,17.7500197 28.7343303,17.7500197 L28.7343303,17.7500197 ' +
  'Z M21.4726289,22.5625082 L13.652335,22.5625082 C13.3945232,22.5625082 13.1796799,22.4765709 13.0078053,22.3046963 ' +
  'C12.8359307,22.1328217 12.7499934,21.9179785 12.7499934,21.6601666 L12.7499934,21.6601666 L12.7499934,20.9726682 ' +
  'C12.7499934,20.5429818 12.8788994,20.1705866 13.1367113,19.8554834 C13.3945232,19.5403802 13.7239497,19.325537 ' +
  '14.1249902,19.2109537 L14.1249902,19.2109537 L15.4570182,18.8672045 C16.0299333,19.296891 16.6887864,19.5260569 ' +
  '17.433576,19.5547029 C18.264303,19.5833489 19.0090933,19.3541823 19.6679457,18.8672045 L19.6679457,18.8672045 ' +
  'L20.9999738,19.2109537 C21.4010143,19.325537 21.7304408,19.5403802 21.9882527,19.8554834 C22.2460646,20.1705866 ' +
  '22.3749705,20.5429818 22.3749705,20.9726682 L22.3749705,20.9726682 L22.3749705,21.6601666 C22.3749705,21.9179785 ' +
  '22.2890332,22.1328217 22.1171586,22.3046963 C21.945284,22.4765709 21.7304408,22.5625082 21.4726289,22.5625082 ' +
  'L21.4726289,22.5625082 Z M28.7343303,20.5000131 L24.265591,20.5000131 C24.1223624,20.5000131 24.0006174,20.4498828 ' +
  '23.9003575,20.3496228 C23.8000975,20.2493629 23.7499672,20.1276179 23.7499672,19.9843893 L23.7499672,19.9843893 ' +
  'L23.7499672,19.6406402 C23.7499672,19.4974116 23.8000975,19.3756666 23.9003575,19.2754067 C24.0006174,19.1751467 ' +
  '24.1223624,19.1250164 24.265591,19.1250164 L24.265591,19.1250164 L28.7343303,19.1250164 C28.8775589,19.1250164 ' +
  '28.9993039,19.1751467 29.0995638,19.2754067 C29.1998238,19.3756666 29.2499541,19.4974116 29.2499541,19.6406402 ' +
  'L29.2499541,19.6406402 L29.2499541,19.9843893 C29.2499541,20.1276179 29.1998238,20.2493629 29.0995638,20.3496228 ' +
  'C28.9993039,20.4498828 28.8775589,20.5000131 28.7343303,20.5000131 L28.7343303,20.5000131 Z'
};

const DocumentDateFormats = (locale) => {
  switch (locale) {
    case 'ja-JP':
    case 'zh-CN':
    case 'zh-HK':
      return 'MMMM Do (ddd)';
    default: return 'DD-MMM-YYYY';
  }
};

const SessionDateFormats = (locale) => {
  switch (locale) {
    case 'ja-JP':
    case 'zh-CN':
    case 'zh-HK':
      return 'MMMM Do (ddd)';
    default: return 'ddd DD MMMM';
  }
};

const DeviceTypes = {
  extraLarge: 'desktop-small',
  large: 'desktop-large',
  tablet: 'desktop-small',
  mobile: 'mobile-small'
};

const Locale = [{
  code: 'en-GB',
  name: 'en-GB'
}, {
  code: 'en-US',
  name: 'en-US'
}, {
  code: 'zh-CN',
  name: 'zh-CN'
}, {
  code: 'zh-HK',
  name: 'zh-HK'
}, {
  code: 'fr-FR',
  name: 'fr-FR'
}, {
  code: 'de-AT',
  name: 'de-AT'
}, {
  code: 'de-DE',
  name: 'de-DE'
}, {
  code: 'it-IT',
  name: 'it-IT'
}, {
  code: 'ja-JP',
  name: 'ja-JP'
}, {
  code: 'ko-KR',
  name: 'ko-KR'
}, {
  code: 'pt-BR',
  name: 'pt-BR'
}, {
  code: 'ru-RU',
  name: 'ru-RU'
}, {
  code: 'es-MX',
  name: 'es-MX'
}, {
  code: 'th-TH',
  name: 'th-TH'
}, {
  code: 'tr-TR',
  name: 'tr-TR'
}, {
  code: 'vi-VN',
  name: 'vi-VN'
}];

const EventCycle = [{
  code: 'Annual',
  name: 'Annual'
},{
  code: 'Quadrennial',
  name: 'Quadrennial'
},{
  code: 'Triennial',
  name: 'Triennial'
},{
  code: 'Biennial',
  name: 'Biennial'
},{
  code: 'Cycling',
  name: 'Cycling'
},{
  code: 'OnOff',
  name: 'OnOff'
}];

const EventType = [{
  code: 'ParentEvent',
  name: 'ParentEvent'
},{
  code: 'OnlineEvent',
  name: 'OnlineEvent'
},{
  code: 'Conference',
  name: 'Conference'
},{
  code: 'Publication',
  name: 'Publication'
},{
  code: 'SubEvent',
  name: 'SubEvent'
},{
  code: 'Membership',
  name: 'Membership'
},{
  code: 'Merchandising',
  name: 'Merchandising'
},{
  code: 'NetworkingAndSpecialExperience',
  name: 'NetworkingAndSpecialExperience'
}];

const Top100Show = [{
  code: 'Top100',
  name: 'Top100'
},{
  code: 'Mega',
  name: 'Mega'
},{
  code: 'N',
  name: 'N'
}];

const BusinessRelationship = [{
  code: 'B2B',
  name: 'B2B'
},{
  code: 'B2C',
  name: 'B2C'
},{
  code: 'B2B2C',
  name: 'B2B2C'
}];

const ShowSettingsFieldErrorSelectors = {
  rXEventCode: /rXEventCode/,
  customerSupportEmail: /customerSupportEmail/
};

const ExtraCharacteristicsType = {
  exhibitor: 'Exhibitor',
  product: 'Product'
};

const Filters = {
  ExhibitorFiltersKey: 'exhibitorFilters',
  ProductFiltersKey: 'productFilters',
  FiltersKey: 'filters',
  ProductAndServicesFilterKeySuffix: '.products_and_services',
  SectorFilterKeySuffix: '.sectors',
  VenueFilterKeySuffix: '.venue_name',
  ExhibitorFeaturesKey: 'exhibitorFeatures',
  ProductFeaturesKey: 'productFeatures',
  FeaturesKey: 'features'
}
const RedirectIds = {
  ProductsSection: 'products_section',
  DocumentsSection: 'documents_section',
  MatchmakingSection: 'matchmaking_section',
}
export const RedirectSectionURL = {
  'product-recommendation': RedirectIds.ProductsSection,
  'matchmaking-recommendation': RedirectIds.MatchmakingSection,
  'brochure-recommendation': RedirectIds.DocumentsSection
};


const MaxProducts = {
  Gold: 40,
  Silver: 2,
  OverLay:40
}

const MaxDocuments = {
  Gold: 40,
  Silver: 2,
  OverLay:40
}

const GalleryCollapsedViewMaxItems = {
  product: {
    desktopOrTablet: 6,
    mobile: 2
  },
  document: {
    desktopOrTablet: 6,
    mobile: 2
  }
}

const ItemType = {
  Document: 'document',
  Product: 'product'
}

const CarouselTabs = {
  productTab: 0,
  documentTab: 1
}

const SwiperBreakpoints = {
  768: {
    slidesPerView: 4,
    spaceBetween: 16,
    slidesPerGroup: 4
  },
  992: {
    slidesPerView: 5,
    spaceBetween: 16,
    slidesPerGroup: 5
  },
  1200: {
    slidesPerView: 6,
    spaceBetween: 16,
    slidesPerGroup: 6
  }
};

const EXHIBITOR_DIRECTORY_RECOMMENDATION = {
  lastVisitedExhibitor: 'lastVisitedExhibitor',
  activeVisitor: 'activeVisitor',
  exhibitorDirectory: 'ed',
  recommendationPath: 'recommendationPage.html#/recommendation/',
}

const ConsentGroups = {
  strictlyNecessary: '1',
  performance: '2',
  functional: '3',
  targeting: '4',
  socialMedia: '5',
}

const VIDYARD_CONFIG = {
  playerScriptUrl: 'https://play.vidyard.com/embed/v4.js'
}

export {
  AlgoliaConstants,
  FilterGroupURLNames,
  FilterGroupNames,
  FieldValidationErrorCodes,
  Devices,
  EmailRegexPattern,
  ImageSizes,
  MaxLength,
  Modes,
  ExhibitorTypes,
  FilterFieldNames,
  FilterFieldErrorSelectors,
  oneMegabyte,
  fiveMegabyte,
  twentyFiveMegabyte,
  MaxFileNameSize,
  MaxFileNameSizeInBytes,
  ProfileFieldNames,
  ProfileFieldErrorSelectors,
  DirectoryDescriptionTrimmedLengths,
  DirectoryDescriptionTrimmedLengthsPackageRedesignFeatureToggle,
  DirectoryObjectiveTrimmedLengths,
  DirectoryObjectiveTrimmedLengthsPackageRedesignFeatureToggle,
  ImageFileExtensions,
  GbsCodesWithInvertedAddressOrder,
  DocumentFileExtensions,
  CertificateFileExtension,
  MaxMobileScreenWidth,
  Packages,
  PackageName,
  filtersAlgoliaPrefix,
  maxFilterItems,
  itemsPerPage,
  ProductsConstants,
  ProductCreditsConstants,
  DigitalIncentivesConstants,
  ProductFieldNames,
  SortDirection,
  ProductFieldErrorSelectors,
  FilterGroupProperties,
  ExhibitorFeatures,
  TestVariantKeys,
  DocumentTypes,
  FavouriteConstants,
  FollowConstants,
  SessionFieldErrorSelectors,
  SessionStorageKeys,
  SocialMediaConstants,
  SocialMediaLogoViewBox,
  SocialMediaKeys,
  PressReleaseDocumentType,
  Sections,
  ManageThirdPartyFieldNames,
  PpsTags,
  CountryFilters,
  PPSSortOrder,
  CompanyNameAideEnabledBUs,
  ImageTypes,
  ScreenSizes,
  EventEditionFeatures,
  EventFormCode,
  EXHIBITOR_INSIGHTS,
  EXHIBITOR_INSIGHTS_TILE_TYPE,
  SecondaryAdminFieldNames,
  DataDtmActions,
  CallToActionConstants,
  RegRedirectConstants,
  Claims,
  Roles,
  ReactSettings,
  DocumentDateFormats,
  SessionDateFormats,
  DeviceTypes,
  Buttons,
  OrganisationGuidFacet,
  Locale,
  Tenants,
  DiscoverConstants,
  ExtraCharacteristicsType,
  PrepopulationStatus,
  PrepopulationType,
  PrePopulateErrorMessage,
  EventCycle,
  EventType,
  Top100Show,
  BusinessRelationship,
  ShowSettingsFieldErrorSelectors,
  Filters,
  PremiumExhibitorPrioritySlots,
  SwiperBreakpoints,
  MaxProducts,
  MaxDocuments,
  ItemType,
  CarouselTabs,
  GalleryCollapsedViewMaxItems,
  EXHIBITOR_DIRECTORY_RECOMMENDATION,
  ConsentGroups,
  RedirectIds,
  FilterGroupIds,
  VIDYARD_CONFIG,
  maxVideoFileDurationInSeconds,
  VideoFileExtensions,
  Platform,
  maxVideoFileNameLength
};
